import * as React from 'react';
export const slackSvg = React.forwardRef(function slackSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E01E5A',
      d: 'M10.202 18.639c0 1.156-.945 2.1-2.101 2.1A2.106 2.106 0 0 1 6 18.64c0-1.157.945-2.101 2.101-2.101h2.101v2.1Zm1.059 0c0-1.157.944-2.101 2.1-2.101 1.157 0 2.101.944 2.101 2.1V23.9a2.106 2.106 0 0 1-2.1 2.101 2.106 2.106 0 0 1-2.101-2.101v-5.26Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#36C5F0',
      d: 'M13.362 10.202a2.106 2.106 0 0 1-2.101-2.101c0-1.156.944-2.101 2.1-2.101 1.157 0 2.101.945 2.101 2.101v2.101h-2.1Zm0 1.059c1.156 0 2.1.944 2.1 2.1a2.105 2.105 0 0 1-2.1 2.101H8.1a2.106 2.106 0 0 1-2.1-2.1c0-1.157.945-2.101 2.101-2.101h5.26Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2EB67D',
      d: 'M21.798 13.362c0-1.157.945-2.101 2.101-2.101 1.156 0 2.101.944 2.101 2.1a2.106 2.106 0 0 1-2.101 2.101h-2.1v-2.1Zm-1.059 0c0 1.156-.944 2.1-2.1 2.1a2.106 2.106 0 0 1-2.101-2.1V8.1c0-1.156.944-2.101 2.1-2.101 1.157 0 2.101.945 2.101 2.101v5.26Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#ECB22E',
      d: 'M18.639 21.798c1.156 0 2.1.945 2.1 2.101A2.106 2.106 0 0 1 18.64 26a2.106 2.106 0 0 1-2.101-2.101v-2.1h2.1Zm0-1.059a2.106 2.106 0 0 1-2.101-2.1c0-1.157.944-2.101 2.1-2.101H23.9c1.156 0 2.101.944 2.101 2.1a2.106 2.106 0 0 1-2.101 2.101h-5.26Z',
    }),
  );
});
slackSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var slack = {
  category: 'brand',
  colorable: false,
  name: 'slack',
  svg: slackSvg,
};
